export default "__VITE_ASSET__D4BP6Ngs__";